import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=5f70ac96&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=5f70ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f70ac96",
  null
  
)

export default component.exports